import React from "react";

interface Props {
  finishes: any;
  currentFinishes: any;
  setCurrentFinishes: (value: any) => void;
}

const Finishes: React.FC<Props> = ({ finishes, currentFinishes, setCurrentFinishes }) => {
  return (
    <div className="tour-sidebar-finishes">
      <div className='tour-sidebar-finishes-title'>{finishes.name}</div>
      <div className='tour-sidebar-finishes-options'>
        {
          finishes?.options?.map( (option: any, index: number) => 
            <div key={option.id} className="tour-sidebar-finishes-option" onClick={() => {setCurrentFinishes(option)}}>
              <img className={`tour-sidebar-finishes-option-img ${(currentFinishes?.id === option.id) ? 'selected' : ''}`} src={option.image.default || option.image} draggable={false} alt=''/>
              <div className='tour-sidebar-finishes-option-title'>{option.name}</div>
            </div>
          )
        }
      </div>
    </div>
  );
};

export default Finishes;